<template>
  <div class="order-detail-payment-contents">
    <tr :class="clickableClass()"
        @click="onRowClick">
      <!-- 決済連携チェックボックス -->
      <td class="center">
        <BaseCell
            v-show="isShowPaymentCooperation"
            :properties="paymentCooperationProperty"
            :display-item="localData"
            :editable="editable[paymentCooperationProperty.editableId]"
            :site-code="siteCode"
            :validate-scope="validateScope" />
      </td>
      <td v-for="(l, index) in paymentsList"
          :key="index"
          :class="l.class">
        <div>
          <BaseOperationTooltip
              v-if="l.slot==='toolTip' && showTooltip"
              :list="getTooltipList()"
              placement="bottom-end"
              class="not-open-dialog" />
          <BaseCell
              v-else
              :properties="l"
              :display-item="payment"
              :editable="editable[l.editableId]"
              :site-code="siteCode"
              :validate-scope="validateScope"
              @change="l.change ? l.change : () => {}" />
        </div>
      </td>
    </tr>
    <!-- 注文支払ダイアログ -->
    <SlipDialog
        type="payment"
        :mode="mode"
        :visible.sync="detailDialogVisible"
        :detail-data="detailData" />
  </div>
</template>

<style>
.clickable {
  cursor: pointer;
}
.order-detail-payment-contents {
  display: contents;
}
.el-message-box.payment-is-processed-alert {
  width: 600px;
  white-space: pre-line;
}
</style>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import * as define from '@/define'
import compareUtils from '@/utils/compareUtils'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import SlipDialog from '@/components/pages/order/SlipDialog'

const EDITABLE = Object.freeze({
  [define.ORDER_MODE.NORMAL]: Object.freeze({}),
  [define.ORDER_MODE.EDIT]: Object.freeze({
    paymentMethod: true,
    paymentAmount: true,
    isProcessed: true
  }),
  [define.ORDER_MODE.SHORTAGE]: Object.freeze({
    paymentMethod: true,
    paymentAmount: true,
    isProcessed: true
  }),
  [define.ORDER_MODE.RECEIVED]: Object.freeze({
    paymentMethod: true,
    paymentAmount: true,
    isProcessed: true
  }),
  [define.ORDER_MODE.EXCHANGE]: Object.freeze({
    paymentMethod: true,
    paymentAmount: true,
    isProcessed: true
  }),
  [define.ORDER_MODE.CAPTURE]: Object.freeze({ paymentCooperation: true }),
  [define.ORDER_MODE.CHANGE_PAYMENT]: Object.freeze({
    paymentMethod: true,
    paymentAmount: true,
    isProcessed: true
  })
})

const isNewRecord = (row) => {
  return _.get(row, 'uuid', '') === ''
}

export default {
  name: 'OrderDetailPaymentTypeRow',
  components: {
    BaseCell,
    BaseOperationTooltip,
    SlipDialog
  },
  mixins: [x, orderUtil],
  inject: ['parentValidator'],
  props: {
    payment: {
      type: Object,
      default: () => ({})
    },
    orderTotalPrice: {
      type: Number,
      default: 0
    },
    amount: {
      type: Number,
      default: 0
    },
    originData: {
      type: Object,
      default: () => []
    },
    mode: {
      type: Number,
      default: define.ORDER_MODE.NORMAL
    },
    validateScope: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      detailDialogVisible: false,
      detailData: {},
      originPayment: {},
      localData: {
        paymentCooperation: false
      }
    }
  },
  computed: {
    define: () => define,
    ...mapGetters('OrderDetail', {
      orderDetail: 'orderDetail',
      siteCode: 'siteCode'
    }),
    ...mapGetters({
      paymentMethodSelectOptions: 'paymentMethodSelectOptions'
    }),
    paymentCooperationProperty () {
      return {
        type: 'String', path: 'paymentCooperation', elementType: ELEMENT_TYPE.CHECK_BOX,
        editableId: 'paymentCooperation', editableCondition: this.editableCondition,
        funcId: define.PermissionKeys.Order.Detail.OrderInfo.PaymentTypeBreakdown.PAYMENT_LINKAGE
      }
    },
    paymentsList () {
      return [
        {
          type: 'String', path: 'isProcessed', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center',
          editableId: 'isProcessed', editableCondition: this.editableCondition, change: this.onChangeisProcessed
        },
        {
          type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => {
            if (isNewRecord(row)) {
              return ''
            } else if ([define.PAYMENT_METHOD_TYPE.NO_PROCESS, define.PAYMENT_METHOD_TYPE.HOLD]
              .includes(row.paymentMethod.methodType)) {
              return '-'
            }
            return this.$_mixin_getCodeName(
              this.$_orderUtil_orderPayment_isPaid(row, row.isPaid, row.amount),
              'd_order_payment.is_paid',
              { siteCode: this.siteCode })
          }
        },
        {
          type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => {
            // return _.chain(row)
            //   .get('paymentSets', [])
            //   .find(val => val.statusCode === define.PAYMENT_SET_STATUS.UNPROCESSED)
            //   .thru(val => val != null ? '予約有り' : '')
            //   .value()
            // 非表示対応
            return ''
          }
        },
        {
          type: 'String', path: 'paymentMethod.code',
          codeName: 'm_payment_method.method_code',
          editType: 'select', selectCode: this.paymentSelectOptions,
          elementType: ELEMENT_TYPE.SELECT_BOX, editableId: 'paymentMethod',
          editableCondition: this.editableCondition,
          validateRule: 'required', validateAs: '支払方法', popoverErrorMsg: true,
          change: (event) => { this.paymentMethodChange(event) }
        },
        {
          type: 'String', path: 'transactionId1'
        },
        {
          type: 'Number', path: 'amount', elementType: ELEMENT_TYPE.INPUT_NUMBER,
          editableId: 'paymentAmount', class: 'right',
          validateRule: `required|checkMinus:${this.payment.paymentMethod.methodType}|checkTotalPriceDifference`,
          validateAs: '金額', popoverErrorMsg: true
        },
        { slot: 'toolTip' }
      ]
    },
    editable () {
      return EDITABLE[this.mode] || {}
    },
    showTooltip () {
      return [define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.RECEIVED, define.ORDER_MODE.EXCHANGE].includes(this.mode)
    },
    cancelAnimation () {
      return this.mode === define.ORDER_MODE.NORMAL
    },
    isShowPaymentCooperation () {
      return [define.ORDER_MODE.CAPTURE].includes(this.mode)
    }
  },
  watch: {
    'localData.paymentCooperation' (val) {
      if (this.mode === define.ORDER_MODE.CAPTURE ||
          !compareUtils.compare(this.originPayment, this.payment)) {
        // 行データ変更済みの場合
        if (val) {
          this.$set(this.payment, 'paymentCooperation', 1)
        } else {
          this.$delete(this.payment, 'paymentCooperation')
        }
      }
    },
    payment: {
      handler: function (val, oldVal) {
        if (this.mode === define.ORDER_MODE.CAPTURE) {
          return
        }
        const tmpPayment = _.chain(this.payment).cloneDeep().omit('paymentCooperation').value()
        if (compareUtils.compare(this.originPayment, tmpPayment)) {
          // 行データが未変更の場合
          this.$delete(this.payment, 'paymentCooperation')
        } else if (this.localData.paymentCooperation) {
          // 行データが変更済みかつ決済連携フラグがONの場合
          this.$set(this.payment, 'paymentCooperation', 1)
        }
      },
      deep: true
    },
    orderTotalPrice (val) {
      this.$validator.validate(`${this.validateScope == null ? '' : this.validateScope + '.'}*`)
    },
    amount (val) {
      this.$validator.validate(`${this.validateScope == null ? '' : this.validateScope + '.'}*`)
    },
    mode (val) {
      this.initializePaymentCooperation()
    },
    detailDialogVisible (val) {
      if (!val) {
        this.detailData = {}
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    this.$validator.extend('checkMinus', {
      getMessage: () => 'この支払方法はマイナスを入力できません。',
      validate: (v, methodType) => {
        if (v >= 0) return true
        if (!_.includes([define.PAYMENT_METHOD_TYPE.CCS, define.PAYMENT_METHOD_TYPE.SITE], +methodType)) return true
        return false
      }
    })

    this.originPayment = _.cloneDeep(this.payment)
    this.initializePaymentCooperation()
  },
  methods: {
    editableCondition (row, path) {
      switch (path) {
        case 'paymentCooperation':
          return +_.get(this.payment, 'amount') > 0 &&
            _.get(this.payment, 'isPaid') === 0 &&
            _.get(this.payment, 'isProcessed') === 1 &&
            this.$_orderUtil_isCapturable_paymentRow(this.payment)
        case 'isProcessed':
          const originRow = _.find(this.originData.payments, { uuid: row.uuid })
          return _.get(originRow, 'isProcessed') === 1 &&
            _.includes([define.PAYMENT_METHOD_TYPE.CCS, define.PAYMENT_METHOD_TYPE.SITE], _.get(originRow, 'paymentMethod.methodType'))
        case 'paymentMethod.code':
          return isNewRecord(row) && !row.readonly
        default:
          return false
      }
    },
    isTotalsMatch () {
      return this.amount === this.orderTotalPrice
    },
    /**
     * Tooltipの項目を返却する.
     * @return {Array}
     */
    getTooltipList () {
      return [
        {
          title: '行削除',
          disabled: () => !isNewRecord(this.payment) || this.mode === define.ORDER_MODE.CHANGE_PAYMENT,
          click: () => this.removeRow()
        }
      ]
    },
    removeRow: function () {
      this.$emit('removeRow')
    },
    onChangeisProcessed (event, row, path) {
      if (!event) {
        this.$alert(
          `支払処理対象のチェックを外して保存した支払方法は
           支払処理の対象外となります。
           一度、支払処理の対象外して保存すると変更できませんので、ご注意ください。`,
          define.MESSAGE_TITLE,
          {
            type: 'warning',
            customClass: 'payment-is-processed-alert',
            showClose: false
          }
        )
      }
    },
    initializePaymentCooperation () {
      if (this.mode === define.ORDER_MODE.CAPTURE) {
        this.localData.paymentCooperation = _.get(this.payment, 'isPaid') === 0
      } else {
        this.localData.paymentCooperation = true
      }
    },
    paymentSelectOptions (row) {
      const options = this.paymentMethodSelectOptions(this.siteCode)
      if (!_.has(row, 'uuid')) {
        // 既に支払方法内訳に存在する支払方法はドロップダウンリストから除外される
        for (const payment of this.orderDetail.payments) {
          if (payment.paymentMethod.code !== '' &&
            payment.paymentMethod.code !== row.paymentMethod.code) {
            const opIndex = options.findIndex(
              item => (item.code === payment.paymentMethod.code))
            if (opIndex >= 0) {
              options.splice(opIndex, 1)
            }
          }
        }
      }
      return row.needsHoldOption ? options : _.reject(options, { methodType: define.PAYMENT_METHOD_TYPE.HOLD })
    },
    clickableClass () {
      if (!this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.PaymentTypeBreakdown.DETAIL)) return
      return 'clickable'
    },
    onRowClick (event) {

      /** ダイアログを開かない要素の判定 */
      // 権限なし
      if (!this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.PaymentTypeBreakdown.DETAIL)) return
      // 文字列選択状態
      if (!window.getSelection().isCollapsed) return
      // input
      if (event.srcElement.tagName.toLowerCase() === 'input') return
      // tooltip
      if (event.srcElement.parentElement.parentElement.classList.contains('el-tooltip')) return
      // checkbox
      if (event.srcElement.parentElement.parentElement.classList.contains('el-checkbox')) return

      this.detailData = this.payment
      this.detailDialogVisible = true
    },
    /**
     * 支払方法マスタ情報を追加した注文支払データに反映する.
     * @param {code}
     */
    paymentMethodChange (code) {
      const options = this.paymentMethodSelectOptions(this.siteCode)
      const option = _.filter(options, { code: code })[0]
      // ポイントフラグ
      this.$set(this.payment.paymentMethod, 'isPoint', option.isPoint)
      // 支払方法名
      this.$set(this.payment.paymentMethod, 'name', option.name)
    }
  }
}
</script>
